<template>
  <Adminlte>
    <div class="col-md-8 col-md-offset-2">
      <div class="box box-primary center-block">
        <div class="box-header with-border">
          <h3 class="box-title">Período para Respostas - {{ (new Date()).getFullYear() }}</h3>
        </div>
        <div class="box-body center-block">
          <form role="form">
            <div class="box-body">
              <div class="form-group">
                <label>Data de abertura</label>
                <DatePicker
                  placeholder="Selecione a data"
                  :bootstrapStyling="true"
                  :disabled="this.quizPeriod.id != null"
                  :disabled-dates="disabledStartingDates"
                  :language="datepickerLanguage"
                  v-model="quizPeriod.startingDate">
                </DatePicker>
                <p v-if="errors.startingDate" class="text-red">{{ errors.startingDate }}</p>
              </div>
              <div class="form-group">
                <label>Data de fechamento</label>
                <DatePicker
                  placeholder="Selecione a data"
                  :bootstrapStyling="true"
                  :disabled-dates="disabledEndingDates"
                  :language="datepickerLanguage"
                  v-model="quizPeriod.endingDate">
                </DatePicker>
                <p v-if="errors.endingDate" class="text-red">{{ errors.endingDate }}</p>
              </div>
              <div class="form-group">
                <label>Data limite para aprovação</label>
                <DatePicker
                  placeholder="Selecione a data"
                  :bootstrapStyling="true"
                  :disabled-dates="disabledApprovalLimitDates"
                  :language="datepickerLanguage"
                  v-model="quizPeriod.approvalLimitDate">
                </DatePicker>
                <p v-if="errors.approvalLimitDate" class="text-red">{{ errors.approvalLimitDate }}</p>
              </div>
            </div>
          </form>
        </div>
        <div class="box-footer">
          <button type="submit" class="btn btn-sm btn-primary pull-right" v-on:click.prevent="onSubmit">
            <i class="fa fa-save"></i>&nbsp; Salvar
          </button>
          <go-back-button></go-back-button>
        </div>
      </div>
    </div>
  </Adminlte>
</template>

<script>
import Adminlte from '@/components/template/Adminlte'
import DatePicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import GoBackButton from '@/components/elements/GoBackButton'
import QuizPeriodClient from '@/services/resource_client/quiz_period'

export default {
  name: 'QuizPeriod',
  components: { Adminlte, DatePicker, GoBackButton },
  data () {
    return {
      datepickerLanguage: ptBR,
      quizPeriod: {
        id: null,
        startingDate: null,
        endingDate: null,
        approvalLimitDate: null
      },
      disabledStartingDates: {
        from: new Date((new Date()).getFullYear(), 11, 31),
        to: new Date((new Date()).getFullYear(), 0, 1)
      },
      disabledEndingDates: {
        from: new Date((new Date()).getFullYear(), 11, 31),
        to: new Date((new Date()).getFullYear(), 0, 1)
      },
      disabledApprovalLimitDates: {
        from: new Date((new Date()).getFullYear(), 11, 31),
        to: new Date((new Date()).getFullYear(), 0, 1)
      },
      errors: []
    }
  },
  mounted () {
    this.getCurrentYearQuizPeriod()
  },
  methods: {
    onSubmit () {
      this.validateForm()
      if (Object.keys(this.errors).length > 0) {
        return
      }
      if (this.quizPeriod.id !== null) {
        this.updateQuizPeriod()
        return
      }
      this.createQuizPeriod()
    },
    getCurrentYearQuizPeriod () {
      let currentYear = (new Date()).getFullYear()
      QuizPeriodClient.getByYear(currentYear).then(r => {
        if (r.data.total === 1) {
          this.quizPeriod.id = r.data[0].id
          this.quizPeriod.startingDate = new Date(r.data[0].startingDate.replaceAll('-', '/'))
          this.quizPeriod.endingDate = new Date(r.data[0].endingDate.replaceAll('-', '/'))
          this.quizPeriod.approvalLimitDate = new Date(r.data[0].approvalLimitDate.replaceAll('-', '/'))

          this.disabledEndingDates.to = this.quizPeriod.endingDate
          this.disabledApprovalLimitDates.to = this.quizPeriod.endingDate
        }
      })
    },
    createQuizPeriod () {
      QuizPeriodClient.post(this.quizPeriod)
      .then(r => {
        this.$notify({ type: 'success', title: 'Sucesso', text: 'Período definido com sucesso.' })
        this.quizPeriod.id = r.data.id
      })
      .catch(e => {
        this.showFormErrorsNotification()
        this.errors = e.response.data.errors
      })
    },
    updateQuizPeriod () {
      QuizPeriodClient.put(this.quizPeriod)
      .then(r => { this.$notify({ type: 'success', title: 'Sucesso', text: 'Período redefinido com sucesso.' }) })
      .catch(e => {
        this.showFormErrorsNotification()
        this.errors = e.response.data.errors
      })
    },
    validateForm () {
      this.errors = []
      if (this.quizPeriod.startingDate >= this.quizPeriod.endingDate) {
        this.errors['startingDate'] = 'A data de abertura não pode ser maior que a data de fechamento'
        this.errors['endingDate'] = 'A data de fechamento não pode ser menor que a data de abertura'
      }

      if (this.quizPeriod.approvalLimitDate <= this.quizPeriod.endingDate) {
        this.errors['approvalLimitDate'] = 'A data limite para aprovação deve ser maior que a data de fechamento'
      }

      if (this.quizPeriod.startingDate === null) {
        this.errors['startingDate'] = 'Selecione a data de abertura'
      }
      if (this.quizPeriod.endingDate === null) {
        this.errors['endingDate'] = 'Selecione a data de fechamento'
      }
      if (this.quizPeriod.approvalLimitDate === null) {
        this.errors['approvalLimitDate'] = 'Selecione a data limite para aprovação'
      }

      if (Object.keys(this.errors).length > 0) {
        this.showFormErrorsNotification()
      }
    },
    showFormErrorsNotification () {
      this.$notify({
        type: 'error',
        title: 'Ocorreu um erro',
        text: 'Verifique se as informações foram preenchidas corretamente e tente novamente.'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// QuizPeriod.vue?3680f9de